import { createApi } from '@reduxjs/toolkit/query/react';
import { APP_JOBS_API } from 'services/constants';
import { rawBaseQuery } from 'services/shared';
import { JobResponse, JobMutation, ResponseJobItem } from 'services/types';

export const jobsApi = createApi({
  reducerPath: APP_JOBS_API,
  baseQuery: rawBaseQuery,
  endpoints: (builder) => ({
    getTasks: builder.query<ResponseJobItem[], void>({
      query: () => encodeURI(`/tasks?taskType=RRP`),
    }),

    postNewJob: builder.mutation<JobResponse, JobMutation>({
      query: ({ body, context }) => ({
        url: encodeURI(`/contexts/${context}/jobs`),
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { usePostNewJobMutation, useGetTasksQuery, useLazyGetTasksQuery } =
  jobsApi;
